import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import {ActivatedRoute} from '@angular/router';
import {LocalStorageService, SessionStorageService} from 'angular-web-storage';
import { environment } from '../../environments/environment';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-sources',
  templateUrl: './sources.component.html',
  styleUrls: ['./sources.component.scss']
})
export class SourcesComponent implements OnInit {

  accessPrivileges: string;
  sourceList: any;
  sourceContent: SafeHtml;
  sourceContent_2: SafeHtml;

  constructor(
    private _appService: AppService,
    private _route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private sessionStorage: SessionStorageService,
    private localStorage: LocalStorageService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    this.spinner.show();

    if (this.sessionStorage.get('accessPrivileges')) {
      this.accessPrivileges = this.sessionStorage.get('accessPrivileges');
    } else {
      this.accessPrivileges = environment.appPrivilege;
    }

    this._appService.getAllSources().subscribe(res => {
      this.sourceList  = res;
      this.spinner.hide();
    });

    this._appService.getConfigDataByPage('sources').subscribe(res => {
      this.sourceContent = this.sanitizer.bypassSecurityTrustHtml(res['config_sources_content']['config_val']);
      this.sourceContent_2 = this.sanitizer.bypassSecurityTrustHtml(res['config_sources_content_2']['config_val']);
    });

  }

}
